import { times } from 'lodash';
import React from 'react';
import styled from 'styled-components';

// Use free Font Awesome half-star that works with the included CSS
const HalfStar = styled.i.attrs(() => ({ className: 'fa-solid fa-star-half-stroke' }))``;

export const starType = (starNum: number, rating: number): 'FULL' | 'HALF' | 'EMPTY' => {
  if (starNum <= rating + 0.2) {
    return 'FULL';
  }

  if (starNum > rating && starNum < rating + 0.9) {
    return 'HALF';
  }

  return 'EMPTY';
};

interface IProps {
  className?: string;
  rating?: number;
}

export const StarRating: React.FC<IProps> = ({ className, rating }) => {
  if (!rating) return null;

  return (
    <div className={`flex flex-row gap-2 text-jackfruit-300 ${className}`}>
      {times(5, (indx) => {
        // Note: rating is out of 100, convert to 5 stars by just dividing by 20
        switch (starType(indx + 1, rating / 20)) {
          case 'FULL':
            return <i key={indx} className='fas fa-star' />;
          case 'HALF':
            return <HalfStar key={indx} />;
          case 'EMPTY':
          default:
            return <i key={indx} className='fas fa-star text-neutral-200' />;
        }
      })}
    </div>
  );
};
